var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _path2, _g27, _g28, _g29, _g30, _path3, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _path4, _path5, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _path6, _g71, _g72, _g73, _g74, _path7, _path8, _g75, _g76, _path9, _path10, _g77, _path11, _g78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPonmetroca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-accessibility_new",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 78"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-account_balance",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-account_box",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 76"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 10H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18zm-9.69-2h7.38c-.69-.56-2.38-1.12-3.69-1.12s-3.01.56-3.69 1.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-account_circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 0 1-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 0 1-6 3.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-arrow_back",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-arrow_forward",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-attach_file",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-build",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31a4.469 4.469 0 0 1 1.24 3.96 4.35 4.35 0 0 1-.88 1.96l9.45 9.45-.88.89z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-burst_mode",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 79"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38l-2 2.57L14 13.47l-2 2.52h8z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-business",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-child_care",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 57"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.94 11.34a4.008 4.008 0 0 0-2.81-3.17 9.114 9.114 0 0 0-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 0 0-2.81 3.17c-.04.21-.06.43-.06.66 0 .23.02.45.06.66a4.008 4.008 0 0 0 2.81 3.17 8.977 8.977 0 0 0 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 0 0 2.8-3.17c.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zm-7 3c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-child_friendly",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2v8h8c0-4.42-3.58-8-8-8zm2 6V4.34c1.7.6 3.05 1.95 3.66 3.66H15zm-8.56 3l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61A7.948 7.948 0 0 0 21 11H6.44zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm.74-5.34l-.29.37A3.505 3.505 0 0 0 13.84 17h-2.68c-.5-1.04-1.5-1.8-2.68-1.97l-.44-.67c-.1-.17-.34-.69-.67-1.36h11.29c-.21.59-.52 1.15-.92 1.66z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 24",
    id: "ca-cittadini",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.7c.8.3 1.5 1.1 1.5 1.9v4c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-4c0-.4-.3-.8-.8-1l-2.1-.6c-.1 0-.1 0-.1-.1l-1.2 1.2v4.4c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-4.4l-1.2-1.2c-.1.1-.3.1-.4.1h-.1c.4.4.7 1.1.7 1.8v3.7c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-3.7c0-.7-.4-1.2-1.1-1.5l-2.6-1.1-1.2 1.9c-.1.3-.4.4-.7.4h-.1c-.3 0-.6-.1-.7-.3l-.8-.8v5c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-5l-.8.8c-.1.1-.4.3-.7.3h-.1c-.3 0-.6-.1-.7-.4l-1.2-1.9-3.2 1.1c-.6.3-1 .8-1 1.5v3.7c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-3.7c0-.6.1-1 .4-1.4l-.3-.2-.6.6c-.4.4-1 .6-1.4.6-.6 0-1-.1-1.4-.6l-.6-.6-1.5.8c-.4.1-.6.6-.6 1v3.6c0 .3-.3.4-.6.4s-.4-.1-.4-.4V20c0-.8.4-1.5 1.1-1.8l1.4-.7C1.1 17 .6 16.1.6 16v-.4c.4-.7.4-1.9.4-3v-1c.1-2.3 1.9-4 4.1-4s4 1.8 4.1 4v1c0 1 .1 2.3.4 3v.4s-.4.8-1.8 1.5l.3.3c.3-.1.4-.3.7-.3l3-1.1c0-.1 0-.3.1-.4l1-1v-1.7c-1.1-1-1.9-2.5-1.9-4.3V7.9c-.6-.7-.7-1.5-.7-2.2V4.6C10.3 2.1 12.4 0 15 0h7.3c.3 0 .6.3.6.4v5.1c0 .8-.1 1.7-.6 2.3v1.4c0 1.5-.7 3-1.8 4.1l-.3.3v1.5l1 1c.1.1.1.3.1.4l2.8 1 1-.3c.4-.1.4-.1.4-.3v-.7c-1-.7-1.5-1.8-1.5-3v-.8l-.3-.6c-.1-.4-.3-.7-.3-1.1 0-1.7 1.4-3 3-3h4.7c.3 0 .6.3.6.4v2.5c0 .4-.1 1-.3 1.4l-.1.4v1c0 1-.4 1.9-1.1 2.6l-.4.4v.7c0 .1 0 .1.1.1l1.6.5zm-4.2-.9c-.3 0-.7 0-1-.1v.4l1.1 1.1 1.1-1.1v-.4c-.4.1-.7.1-1.2.1.1 0 0 0 0 0zm-2.5-3.7c0 1.5 1.1 2.6 2.5 2.8.7 0 1.4-.3 1.9-.7.6-.6.8-1.1.8-1.9v-1-.3l.3-.6c.1-.3.3-.6.3-1V8.7h-4.1c-1.1 0-2.1 1-2.1 2.1 0 .3 0 .6.1.7l.3.6v1zm-6.2 5.5l1.5-2.2-.6-.6-2.2 1.7 1.3 1.1c-.2 0-.2 0 0 0zm-4 0l1.2-1.2-2.3-1.5-.6.6 1.7 2.1c-.2 0-.2 0 0 0zm1.5-3.8c-.8 0-1.5-.3-2.2-.7v.8l2.6 1.8 2.6-1.8v-.8c-.8.6-1.7.7-2.6.7h-.4zm12.7-3.1c-.8-.4-2.3-.4-2.9-.4-.3 0-.6-.3-.6-.4 0-.3.3-.4.6-.4.1 0 2.2 0 3.3.6.3.1.3.4.3.7-.1.1-.3.3-.4.3-.2-.4-.3-.4-.3-.4zM11.8 9c0 2.5 1.9 4.7 4.4 4.8 1.1.1 2.2-.3 3.2-1 .1-.1.3-.1.4-.3 1-.8 1.5-2.1 1.5-3.4V7.9v-.3c.3-.7.4-1.4.4-2.1V1H15c-2.1 0-3.7 1.7-3.7 3.6v1c0 .7.1 1.4.4 2.1V9h.1zm-7.4 9.1c.4.4 1.1.4 1.5 0l.4-.4c-.1-.1-.1-.3-.1-.4v-.6c-.3.1-.7.1-1.1.1s-.7 0-1.1-.1v.6c0 .1 0 .3-.1.4l.5.4zm-2.9-2.2c.1.3.7.7 1.5 1v-.6c-.6-.4-1-1-1.2-1.5-.1.2-.2.6-.3 1.1zm.5-4.2v1.1h.1c.3 0 .6.3.6.4 0 1.4 1.2 2.6 2.6 2.6 1.2 0 2.3-1 2.6-2.2-.8-1.7-2.8-1.9-3.4-1.9l-.7.7c-.1.1-.6.1-.7 0-.4-.1-.4-.4-.3-.6l.8-1c.1-.1.3-.1.3-.1s.8 0 1.8.3c1.2.3 2.1 1 2.5 1.8v-.1-1c0-.8-.4-1.7-1-2.2-.6-.6-1.4-1-2.2-1s-1.7.3-2.2 1c-.4.6-.8 1.4-.8 2.2zm5.1 5.1c1-.3 1.4-.7 1.5-1-.1-.3-.3-.7-.3-1.1-.3.7-.7 1.2-1.2 1.5v.6zM30.4 20c.3 0 .6.3.6.4v3c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-3c.2-.3.5-.4.6-.4zm-27.8.6c.3 0 .6.3.6.4v2.5c0 .3-.3.4-.6.4s-.6-.3-.6-.5V21c0-.2.3-.4.6-.4zM13.3 5.5v1.1c0 .3-.3.4-.6.4-.1 0-.4-.1-.4-.4V5.5c0-.6.4-1 .8-1 1.5-.3 5.4-.6 7.2 1.2.3.1.3.4.1.7-.1.1-.6.1-.7 0-.7-.7-1.8-1-3.3-1.1-1.1-.1-2.4.1-3.1.2zM10.8 21c.3 0 .6.3.6.4v2.1c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-2.1c.1-.2.4-.4.6-.4zm11.4 0c.3 0 .6.3.6.4v2.1c0 .3-.3.4-.6.4s-.6-.3-.6-.4v-2.1c.1-.2.3-.4.6-.4z",
    "data-name": "Livello 22"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-clear",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-color_lens",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 84"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 12 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 11.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 24",
    preserveAspectRatio: "xMinYMid meet",
    id: "ca-consiglio",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.6c0 1.8 1.4 3.3 3.3 3.3 1.7 0 3.3-1.4 3.3-3.3 0-1.8-1.4-3.3-3.3-3.3s-3.3 1.4-3.3 3.3zm3.2-1.5c.8 0 1.4.7 1.4 1.4 0 .8-.7 1.4-1.4 1.4s-1.4-.7-1.4-1.4.7-1.4 1.4-1.4zM28.6 15.8h-3.7c-1.6 0-2.7 1.2-2.7 2.7v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-.5.4-.9.9-.9h3.7c.5 0 .9.4.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-1.5-1.2-2.7-2.7-2.7zM12.4 10.6c0 1.8 1.4 3.3 3.3 3.3 1.8 0 3.3-1.4 3.3-3.3 0-1.8-1.4-3.3-3.3-3.3s-3.3 1.4-3.3 3.3zm3.3-1.5c.8 0 1.4.7 1.4 1.4 0 .8-.7 1.4-1.4 1.4s-1.4-.7-1.4-1.4c-.1-.7.6-1.4 1.4-1.4zM13.4 3.3C13.4 1.4 12 0 10.2 0 8.3 0 6.9 1.4 6.9 3.3s1.4 3.3 3.3 3.3c1.7-.1 3.2-1.5 3.2-3.3zm-3.2 1.4c-.8 0-1.5-.7-1.5-1.4s.7-1.4 1.4-1.4c.8 0 1.4.7 1.4 1.4s-.5 1.4-1.3 1.4zM17.5 15.8h-3.7c-1.6 0-2.7 1.2-2.7 2.7v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-.5.4-.9.9-.9h3.7c.5 0 .9.4.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-1.5-1.2-2.7-2.7-2.7zM6.4 15.8H2.7C1.2 15.8 0 17 0 18.5v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-.5.4-.9.9-.9h3.7c.5 0 .9.4.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9v-4.6c0-1.5-1.1-2.7-2.7-2.7zM4.6 13.8c1.8 0 3.3-1.3 3.3-3.1S6.5 7.3 4.6 7.3c-1.8 0-3.3 1.4-3.3 3.3 0 1.8 1.4 3.2 3.3 3.2zm0-4.7c.7 0 1.4.7 1.4 1.5 0 .7-.7 1.4-1.4 1.4-.8 0-1.4-.7-1.4-1.4-.1-.8.6-1.5 1.4-1.5zM24.9 3.3c0-1.8-1.4-3.3-3.3-3.3-1.8 0-3.3 1.4-3.3 3.3s1.4 3.3 3.3 3.3c1.9-.1 3.3-1.5 3.3-3.3zm-3.2 1.4c-.8 0-1.4-.7-1.4-1.4s.7-1.4 1.4-1.4c.8 0 1.4.7 1.4 1.4s-.7 1.4-1.4 1.4z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-contact_phone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 27"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zm-2.99-1.01L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64L21 8l-1.99-1.99A7.474 7.474 0 0 0 16.28 10c-.18.64-.28 1.31-.28 2s.1 1.36.28 2a7.512 7.512 0 0 0 2.73 3.99zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-credit_card",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 85"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 80"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-date_range",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 30"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-delete_outline",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 31"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-description",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-directions",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.43 10.59l-9.01-9.01c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.79-.76.8-2.02.03-2.82zm-10.42 10.4l-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-directions_bike",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 82"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-directions_car",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 86"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 14.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-directions_subway",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 1.5
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-directions_walk",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 0 0-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-elezioni",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.4c-.1-.2-.3-.3-.5-.3h-2.7V13c0-.8-.7-1.5-1.5-1.5H17v-1.2c0-.6-.2-1.1-.6-1.5L9.3 1.4c-.8-.8-2-.9-2.9-.3L3 3.4c-.6.4-1 1.2-.9 1.9l.7 5.1c0 .7.3 1.4.7 1.9l1.2 1.4v3.4H2.5c-.2 0-.4.1-.5.3l-2 6c0 .1 0 .3.1.4.1.1.2.2.4.2h23c.2 0 .3-.1.4-.2.1-.1.1-.3.1-.4l-2-6zm-4.6-4.9c.3 0 .5.2.5.5v7.7H5.7v-5.8c0 .1.1.1.1.2l1.8 3.2c.4.3.7.7 1.2.8h.1c.3.1.5.2.8.2.8 0 1.5-.4 1.9-1.1.4-.7.4-1.5.1-2.1l-1.8-3.6h7.5zm-13-.8c-.4-.4-.6-.9-.6-1.4l-.7-5.2c0-.4.1-.7.4-1L7 1.9c.5-.3 1.2-.3 1.6.2l7.1 7.4c.2.2.3.5.3.8v1.2H9.4l-.4-.9c-.1-.2-.4-.3-.7-.2-.3.1-.4.4-.3.7l2.8 5.5c.2.4.2 1-.2 1.4-.3.4-.9.5-1.3.3h-.1c-.3-.1-.5-.3-.6-.5l-1.8-3.2c-.1-.1-.1-.2-.2-.3l-2.2-2.6zM1.2 23l1.6-4.9h1.9v2.6h-1c-.3 0-.5.2-.5.5s.2.5.5.5h15.9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-.9v-2.6h2.4l1.6 4.9H1.2z",
    "data-name": "Livello 81"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-event",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-event_seat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v7H9V5h6m0-2H9c-1.1 0-2 .9-2 2v9h10V5c0-1.1-.9-2-2-2zm7 7h-3v3h3v-3zM5 10H2v3h3v-3zm15 5H4v6h2v-4h12v4h2v-6z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-exit_to_app",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 78"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-face",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 71"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM15 11.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 0 0 3.66-4.44 8.046 8.046 0 0 0-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 0 1-7.76-3.69A10.016 10.016 0 0 1 4 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.707 21v-8.05H7v-3.2h2.707V7.219c0-1.336.375-2.373 1.125-3.112C11.582 3.37 12.578 3 13.82 3c1.008 0 1.828.047 2.461.14v2.848h-1.687c-.633 0-1.067.14-1.301.422-.188.235-.281.61-.281 1.125V9.75H16l-.422 3.2h-2.566V21H9.707z",
    "data-name": "Livello 70"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-favorite_border",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-fingerprint",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 74"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28zM3.5 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 0 1-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 0 1-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-format_paint",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3zm-2 2H6V4h10v2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-forum",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v7H5.17L4 12.17V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-giunta",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM22.6 5h-3.9c-.5-.9-1.6-1.2-2.5-.8-.9.4-1.4 1.4-1.1 2.4.3 1 1.2 1.6 2.2 1.4 1-.1 1.7-1 1.7-2h3.6c.2 0 .4.2.4.4v4.3c0 .2-.2.4-.4.4H22c-.3 0-.5.2-.5.5V17h-2v-1.1c.6-.2 1-.7 1-1.3v-4.3c0-.8-.6-1.4-1.4-1.4h-4.3c-.8 0-1.4.6-1.4 1.4v.7h-3v-.6C10.4 9.6 9.8 9 9 9H4.9c-.8 0-1.4.6-1.4 1.4v4.3c0 .6.4 1.1 1 1.3v1h-2v-5.5c0-.3-.2-.5-.5-.5h-.6c-.2 0-.4-.2-.4-.4V6.3c0-.1.2-.3.4-.3H5c0 1 .7 1.9 1.7 2s2-.5 2.2-1.5c.2-1-.2-2-1.2-2.4-.9-.4-2 0-2.5.8H1.4C.6 5 0 5.6 0 6.4v4.3c0 .7.6 1.3 1.4 1.3h.1v5.5c0 .3.2.5.5.5h3v3.5c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5v-3.8c.2.2.6.3.9.3h.1v5.5c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5V18h.1c.3 0 .6-.1.9-.3v3.8c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5V18h3c.3 0 .5-.2.5-.5V12h.1c.8 0 1.4-.6 1.4-1.4V6.3c0-.7-.6-1.3-1.4-1.3zM17 7c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm1.5 7.4V15c-.3 0-.5.2-.5.5V21H6v-5.5c0-.3-.2-.5-.5-.5h-.6c-.2 0-.4-.2-.4-.4v-4.3c0-.2.2-.4.4-.4h4.3c.2 0 .4.2.4.4v.7c-.7.2-1.1.8-1.1 1.4zm6.1 4.2c-.1.2-.3.4-.5.4h-.6c-.3 0-.5.2-.5.5V23h-2v-5.5c0-.3-.2-.5-.5-.5h-.6c-.2 0-.4-.2-.4-.4v-4.3c0-.2.2-.4.4-.4h4.3c.2 0 .4.2.4.4v4.3zm3.9-1.6c-.3 0-.5.2-.5.5V21h-2v-5.5c0-.3-.2-.5-.5-.5v-2.6c0-.6-.4-1.1-1-1.3v-.7c0-.2.2-.4.4-.4h4.3c.2 0 .4.2.4.4v4.3c-.1.1-.3.3-.5.3h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM3.5 4c1.1 0 2-.9 2-2 0-.5-.2-1-.6-1.4C4.5.2 4 0 3.5 0c-1.1 0-2 .9-2 2s.9 2 2 2zm0-3c.6 0 1 .4 1 1 0 .3-.1.5-.3.7s-.4.3-.7.3c-.6 0-1-.4-1-1s.4-1 1-1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-grain",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 70"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-group_add",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-3h3v-2H5V7H3v3H0v2h3v3zm7-1.25c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM7.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H7.34zM12 12c1.93 0 3.5-1.57 3.5-3.5S13.93 5 12 5 8.5 6.57 8.5 8.5 10.07 12 12 12zm0-5c.83 0 1.5.67 1.5 1.5S12.83 10 12 10s-1.5-.67-1.5-1.5S11.17 7 12 7zm5 5c1.93 0 3.5-1.57 3.5-3.5S18.93 5 17 5c-.24 0-.48.02-.71.07a5.416 5.416 0 0 1-.02 6.85c.24.05.48.08.73.08zm2.32 2.02c1 .81 1.68 1.87 1.68 3.23V19h3v-1.75c0-1.69-2.44-2.76-4.68-3.23z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-home",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-how_to_reg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 83"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2a9.34 9.34 0 0 0-1-.06c-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-how_to_vote",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 89"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 0 0 2-2v-4l-3-3zm1 7H5v-1h14v1zm-7.66-4.98c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 0 0 0-1.41L14.16 2.3a.975.975 0 0 0-1.4-.01L6.39 8.66a.996.996 0 0 0 0 1.41l4.95 4.95zm2.12-10.61L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 24",
    preserveAspectRatio: "xMinYMid meet",
    id: "ca-iti",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5h1.3v.9H19zM19.5 10.3h.9v1.8h-.9zM2.2 20.5h21.3v.9H2.2zM24.8 20.5h3.5v.9h-3.5zM5.3 23.1H8v.9H5.3zM9.3 23.1h15.5v.9H9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 15.2h-.9v2.6h-.5v-7C29.5 10.6 31 9 31 7.2c0-2.1-1.7-3.6-3.6-3.6-2.1 0-3.6 1.7-3.6 3.6 0 1.8 1.4 3.4 3.2 3.6v7h-.5v-1.5h-.9v1.5h-.4v-.6c0-5.4-4.4-9.8-9.8-9.8s-9.8 4.4-9.8 9.8v.6H4.1v-7c1.8-.2 3.3-1.8 3.3-3.6 0-2.1-1.7-3.6-3.6-3.6S0 5.3 0 7.4c0 1.8 1.4 3.4 3.2 3.6v7h-.5v-2.6h-.8V18h-.5v-1.7H.5v1.5H.1v.9h30.5v-.9h-1.4v-2.6zm-26-5.1C1.9 9.8.9 8.6.9 7.4c0-1.5 1.3-2.7 2.8-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.4-1 2.6-2.3 2.7v-2h-.9v2zm7.9 7.7h-.4v-2.6h-.9v2.6h-.3v-3.2H11v3.2zm6.1 0h-3.9v-7.1h1.8v5.5h2.1v1.6zm2.9 0h-.6v-3.2h.6v3.2zm4 0h-3.2v-4.1h-2.3v4.1h-.8v-2.5h-2.1V9.8h-3.5v8H12v-4.1H8.6v4.1H6.5c-.1-.3-.1-.4-.1-.6 0-4.9 4-8.9 8.9-8.9s8.9 4 8.9 8.9c-.1.2-.1.3-.1.6zm2.9-7.7c-1.4-.3-2.5-1.4-2.5-2.7 0-1.5 1.3-2.7 2.8-2.7s2.8 1.3 2.8 2.7c0 1.4-1 2.6-2.3 2.7v-2H27v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 6.3h5.4c1 0 1.9-.9 1.9-1.9s-.9-2.1-1.9-2.1C19.1 1 17.9 0 16.6 0c-1.2 0-2.2.8-2.6 1.9-1.1.2-2 1.1-2 2.2 0 1.2.9 2.2 1.9 2.2zm0-3.3h.3l.4.1.1-.5c.1-.9.9-1.7 1.9-1.7 1 0 1.8.8 1.9 1.9v.5h.8c.5 0 1 .5 1 1s-.5 1-1 1h-5.4c-.6 0-1.2-.5-1.2-1.2S13.3 3 13.9 3z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-layers",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 61"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-linear_scale",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 0 0 0 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 0 0 0-5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-local_library",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zm7 5.58c-2.53.34-4.93 1.3-7 2.82a15.2 15.2 0 0 0-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27A11.18 11.18 0 0 1 19 10.18v6.95z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-local_parking",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 69"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-location_city",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 75"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-map",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 79"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-nature_people",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 81"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0 0 14 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 0 0 6.17-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-opacity",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 65"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 0 0 4 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0 0 11.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-opendata",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 16.8c1.9.6 4.4.9 7.1.9 2.7 0 5.3-.4 7.1-.9.9-.3 1.7-.6 2.3-1.1.6-.4 1-1 1-1.7V5.3v-.1-.1c0-.6-.5-1.2-1-1.6-.6-.4-1.4-.8-2.3-1.1-1.9-.3-4.4-.6-7.1-.6-2.8 0-5.3.3-7.1.9-.9.3-1.7.6-2.3 1.1-.6.4-1 1-1 1.6v13c0 .7.4 1.3 1 1.7.6.4 1.4.8 2.3 1.1 1.9.6 4.4.9 7.1.9 1.8 0 3.5 0 5-.3.3-.1.5-.4.5-.7-.1-.3-.4-.6-.7-.5-1.4.3-3 .3-4.8.3-2.7 0-5.1-.3-6.8-.9-.8-.3-1.5-.6-1.9-.9-.4-.3-.5-.5-.5-.7v-2.5c.6.4 1.3.7 2.1.9zm-1.6-12c.4-.3 1.1-.6 1.9-.9 1.7-.5 4.1-.9 6.8-.9s5.1.3 6.8.9c.8.3 1.5.6 1.9.9.4.3.5.5.5.7s-.1.4-.5.7c-.4.3-1.1.6-1.9.9-1.7.5-4.1.9-6.8.9s-5.1-.4-6.8-.9c-.8-.3-1.5-.6-1.9-.9-.4-.3-.5-.5-.5-.7s.1-.4.5-.7zm-.6 4.9V7.4c.6.4 1.3.7 2.1.9 1.9.6 4.4.9 7.1.9s5.3-.4 7.1-.9c.8-.3 1.5-.6 2.1-.9v2.4c0 .2-.1.4-.5.7s-1.1.6-1.9.9c-1.7.5-4.1.9-6.8.9s-5.1-.3-6.8-.9c-.8-.3-1.5-.6-1.9-.9-.4-.3-.5-.5-.5-.8 0 .1 0 .1 0 0zm0 4.5v-2.5c.6.4 1.3.7 2.1.9 1.9.6 4.4.9 7.1.9s5.3-.4 7.1-.9c.8-.3 1.5-.6 2.1-.9v2.5c0 .2-.1.4-.5.7-.4.3-1.1.6-1.9.9-1.7.5-4.1.9-6.8.9s-5.1-.3-6.8-.9c-.8-.3-1.5-.6-1.9-.9-.4-.3-.5-.5-.5-.7zM23.2 18.5h-2.5v-.9c0-.1 0-.1.1-.2s.3-.1.5-.1.4.1.5.1c.1.1.1.1.1.2 0 .2.1.4.3.5.2.1.4.1.6 0 .2-.1.3-.3.3-.5 0-.5-.3-.9-.6-1.2-.4-.3-.8-.3-1.2-.3-.4 0-.7 0-1.1.3-.4.3-.6.7-.6 1.2v.9H19h-.1c-.3 0-.6.3-.6.6v4.3c0 .3.3.6.6.6h4.3c.3 0 .6-.3.6-.6v-4.3c0-.3-.3-.6-.6-.6zm-.5 4.4h-3.1v-3.1h3.1v3.1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-pa",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 7.6c.1.1.2.2.2.4v.9c0 .6-.4 1.1-.9 1.3v1.5c0 .3-.2.5-.5.5h-.5v5.3h.5c.3 0 .5.2.5.5v1.7c.3.2.5.6.6 1l.4 2.9c0 .1 0 .3-.1.4-.1.1-.2.2-.4.2H.5c-.1 0-.3-.1-.4-.2-.1-.3-.1-.4-.1-.5l.4-2.9c0-.4.3-.7.6-1v-1.7c0-.3.2-.5.5-.5H2v-5.3h-.6c-.3 0-.5-.2-.5-.5v-1.5C.4 10 0 9.5 0 8.9V8c0-.2.1-.3.2-.4C.3 7.6 11.7.1 11.7.1c.2-.1.4-.1.5 0l11.6 7.5zm-1.2 1.8c.3 0 .5-.2.5-.5v-.5H.9v.5c0 .3.2.5.5.5h21.2zm-3.4 1.8h3v-.9h-3v.9zM1 23.1h22l-.3-2.4c0-.2-.2-.4-.5-.4H1.7c-.2 0-.4.2-.5.4L1 23.1zm.9-4.7v.9h3v-.9h-3zm.9-1h1.1v-5.3H2.8v5.3zm7.8 1h-3v.9h3v-.9zm-2-1h1.1v-5.3H8.6v5.3zm7.8 1h-3v.9h3v-.9zm-2.1-1h1.1v-5.3h-1.1v5.3zm5.8 0h1.1v-5.3h-1.1v5.3zm2 1h-3v.9h3v-.9zm-3.9-8.1h-.9v1.4c0 .3-.2.5-.5.5h-.5v5.3h.5c.3 0 .5.2.5.5v1.4h.9V18c0-.3.2-.5.5-.5h.5v-5.3h-.5c-.3 0-.5-.2-.5-.5v-1.4zm-1.8 0h-3v.9h3v-.9zm-3.9 0h-.9v1.4c0 .3-.2.5-.5.5h-.5v5.3h.5c.3 0 .5.2.5.5v1.4h.9V18c0-.3.2-.5.5-.5h.5v-5.3H13c-.3 0-.5-.2-.5-.5v-1.4zm-1.9 0h-3v.9h3v-.9zm-3.9 0h-.9v1.4c0 .3-.2.5-.5.5h-.5v5.3h.5c.3 0 .5.2.5.5v1.4h.9V18c0-.3.2-.5.5-.5h.5v-5.3h-.5c-.3 0-.5-.2-.5-.5v-1.4zm-1.9 0h-3v.9h3v-.9zM12 1L2 7.5h20L12 1zm0 1.8c1 0 1.9.8 1.9 1.9S13 6.6 12 6.6s-1.9-.8-1.9-1.9.9-1.9 1.9-1.9zm0 2.8c.5 0 .9-.4.9-.9s-.4-1-.9-1-.9.4-.9.9.4 1 .9 1zM4.4 21.2c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm15.2 0c.3 0 .5.2.5.5s-.2.5-.5.5H6.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h13.4z",
    "data-name": "Livello 23"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-people",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z",
    "data-name": "Livello 16"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-person_add",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 88"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-pets",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 51"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-phone_in_talk",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm4 0h2a9 9 0 0 0-9-9v2c3.87 0 7 3.13 7 7zm1 3.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-phonelink_ring",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-pin_drop",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 87"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 20h14v2H5zM18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zM8 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.13-2.08 5.46-4 7.91-1.92-2.44-4-5.78-4-7.91zm4-2c-1.1 0-2 .9-2 2s.9 2 2 2a2 2 0 1 0 0-4z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-place",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2.5
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-play",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 70"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 24",
    preserveAspectRatio: "xMinYMid meet",
    id: "ca-ponmetro",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 19.5c.2.2.3.2.5 0v-1.8c0-.3-.2-.6-.3-.8-.2-.2-.5-.3-.8-.3H8.6v2.5c0 .2.2.3.2.3.2.2.2.2.3.2s.3-.2.3-.2 0-.2.2-.2v-1.9h1s.2.2.2.3V19c-.1.3 0 .5 0 .5zM6 20.7l-3.8.3v2.5c0 .2.2.3.2.3.1.2.1.2.3.2.1 0 .3-.2.3-.2.2-.2.2-.2.2-.3v-1.9h1c.2 0 .3.2.3.3v1.4c0 .2.2.3.2.3.2.2.3.2.5 0s.2-.2.2-.3v-1.9h1s.2.2.2.3v1.4c0 .2.2.3.2.3.2.2.3.2.5 0s.2-.2.2-.3v-1.4c0-.3-.2-.6-.3-.8-.6 0-.9-.2-1.2-.2zM12.4 20.9h-.5v-.3c0-.2-.2-.3-.2-.3-.2-.2-.3-.2-.5 0s-.2.2-.2.3v.3c0 .1-.2.1-.2.3l.2.2c0 .2 0 .2.2.2v1.3c0 .6.3.9.9.9.5 0 .6 0 .6-.3 0-.2-.2-.3-.2-.3-.2-.2-.2-.2-.3-.2h-.5v-1.5h.5c.2 0 .2-.2.5 0 .2-.2.2-.3 0-.5s-.2-.1-.3-.1zM7.7 19.3c.3-.3.5-.6.3-1.1 0-.5-.2-.8-.5-1.1-.2-.3-.5-.5-.9-.5-.3 0-.6.2-.9.5-.3.3-.5.8-.5 1.1 0 .5 0 .8.3 1.1.3.3.6.5 1.1.5s.8-.2 1.1-.5zM6 18.2c0-.2.2-.3.3-.6.2-.2.3-.2.5-.2s.3 0 .5.2.2.5.2.6c0 .3 0 .5-.2.6-.1.2-.2.2-.5.2-.5 0-.8-.3-.8-.8zM8.9 20.7c-.3 0-.9.2-1.1.5-.2.3-.3.6-.3 1.1s0 .8.3 1.1c.3.2.6.3 1.1.3.2 0 .3-.2.3-.2.2 0 .2 0 .2-.2s-.2-.3-.2-.3c-.2-.2-.2-.2-.3-.2-.3 0-.5-.2-.6-.3h1.9v-.3c0-.5-.2-.8-.3-1.1-.2-.2-.5-.4-1-.4zM8.3 22c0-.5.3-.6.8-.6.3 0 .6.3.6.6H8.3zM3 20.4v-.6h.5c.3 0 .8-.2.9-.5.2-.3.3-.6.3-1.1s0-.8-.2-1.3c-.2-.3-.6-.5-.9-.5-.2 0-.3.2-.5.2-.1-.1-.1-.1-.3-.1-.2 0-.3.2-.3.2-.2.2-.2.2-.2.3v3.1c0 .2.2.3.2.3.2.2.3.2.5 0zm0-2.5c0-.3.2-.5.5-.3.2 0 .3 0 .5.2s.2.3.2.5 0 .3-.2.5c-.2 0-.4.2-.5.2-.2 0-.3 0-.5-.2v-.9zM7.7 9.5c.2.6 1.1.3.9-.3-.1-.8-.3-1.6-.4-2.4-.2-.6-1.1-.3-1 .3.2.8.3 1.6.5 2.4zM23.2 12c-.3.5-.6.9-.8 1.4-.5.5.5.9.8.5.2-.5.5-.9.8-1.4.4-.5-.5-1-.8-.5zM14.7 20.7c-.3 0-.5.2-.6.2h-.3c0-.2-.2-.3-.3-.3-.2 0-.3.2-.3.2-.2.1-.2.1-.2.2v2.2c0 .2.2.3.2.3.2.2.3.2.5 0s.2-.2.2-.3V22c0-.2.2-.3.3-.5.2-.2.3-.2.5-.2h.2l.2-.2c.2 0 .2 0 .2-.2-.3 0-.4-.2-.6-.2zM23 15.2l-.8.9c-.2.2-.2.5 0 .6s.5.2.6 0l.8-.9c.2-.2.2-.5 0-.6-.1-.1-.4-.1-.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 21.8c-.2-.3-.6-.2-.9.2-2.5 1.7-5.9 1.3-8.6.3-1.6-.5-3-1.4-4.4-2.3-.3-.2-.5-.5-.8-.6l5.6-4.8.2.2c.3.5 1.1-.2.6-.6l-5.3-5c0-.2-.2-.2-.2-.2l2-3.1h.2c.5.3 1.1-.5.5-.8L17.7.3c-.5-.3-1.1.5-.5.8h.2L15 7l-4.2-1.3v-.9c.6-.2.3-1.1-.3-.9L.3 5.7c-.6.2-.3 1.1.4.9h.2l3.4 6.9c-.6.3-1.1.5-1.7.8-.8.5-.5 1.1.3.8.6-.3 1.1-.6 1.7-.8 0 .2.2.2.2.3.3.6 1.1.2.8-.5V14c1.4-.5 3-.8 4.4-.8v.9c0 .6.9.6.9 0v-.9c.8 0 1.6.2 2.3.3.3 0 .5 0 .8.2l-.3.6c-.2.6.8.9.9.3l.3-.6c1.1.5 2.2 1.3 3.1 2.2l-.6 1.1c-.5.5.5.9.8.5l.8-.6c.5.6.9 1.3 1.6 1.9l.6.6-.6.5c-.6.3.2 1.1.6.6l.6-.6c4.2 3.4 10.6 5.5 15.5 2.3.1-.1.4-.5.1-.7zM9.9 12.3c-1.6.2-3.1.5-4.7.9L1.7 6.5l8.1-1.6v7.4zm4.5.4c-.6-.2-1.3-.3-1.9-.3-.5-.2-1.1-.2-1.7-.2V6.8L16 8.4c-.5 1.5-1.1 2.9-1.6 4.3zm4.4 2.2c-.9-.8-2.2-1.6-3.4-2 .5-1.4.9-2.8 1.6-4.5.5.2.8-.8.2-.9L16 7.1l2.3-5.9L25 5l-6.2 9.9zm1.2 1.4c-.2-.2-.3-.5-.6-.6l3.9-6.1 4.4 4.1-5.6 4.8c-.6-.6-1.4-1.4-2.1-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 5.5c-.3.8-.8 1.4-1.1 2-.3.5.5 1.2.8.5.3-.6.8-1.4 1.1-2 .3-.5-.5-1.1-.8-.5zM18.3 9.5l-1.1 1.9c-.5.5.5.9.8.5l1.1-1.9c.5-.5-.5-1-.8-.5zM16.9 20.7c-.5 0-.8.2-.9.5-.3.3-.5.8-.5 1.1 0 .5 0 .8.3 1.1.3.3.6.5 1.1.5s.8-.2 1.1-.5c.2-.3.3-.6.3-1.1 0-.5-.2-.8-.5-1.1-.1-.3-.4-.5-.9-.5zm.5 2c-.2.2-.3.2-.3.2-.5 0-.8-.3-.8-.8 0-.3 0-.5.2-.6.2-.2.3-.2.5-.2s.3 0 .5.2.2.5.2.6c-.2.3-.2.5-.3.6zM3.9 7.7L5 10.2c.2.6 1.1.2.8-.5C5.5 9 5 8 4.7 7.3c-.1-.7-1.1-.2-.8.4zM12.9 8.8c-.2.6-.5 1.3-.6 1.9-.3.6.8.9.9.3.2-.6.5-1.3.6-1.9.3-.6-.8-.9-.9-.3z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-pool",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 2.5
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 24",
    preserveAspectRatio: "xMinYMid meet",
    id: "ca-portaporta",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2 6.1V4.6l.6-.4v-.5l-.6.3v-.3l1-.6v-.6l-.9.1v-.3l-4.8 1v11.2l2.3-.5v-2.3c.2-.3.4-.6.8-.7.4-.1.8.1.8.4v2.3l.8-.1V8.3l1 .6 4.8-1-3.8-2.2-2 .4zM18.5 17h.6v3.6h-.6zM15.1 17.1h-.6v3.5H17v-.5h-1.9zM2.2 17.5c.4 0 .8.1 1 .5l.4-.5c-.4-.4-.9-.6-1.4-.5-.5 0-.9.1-1.3.5s-.5.8-.5 1.3c-.1.9.8 1.8 1.8 1.8.5 0 1.2-.3 1.4-.6l-.4-.4c-.3.3-.6.5-1 .5s-.7-.1-.9-.4c-.3-.2-.3-.6-.3-.9 0-.4.1-.6.3-.9.3-.3.5-.4.9-.4zM11.4 17.5c.4 0 .8.1 1 .4l.4-.5c-.4-.4-.9-.5-1.4-.5s-1 .1-1.3.5c-.4.4-.5.8-.5 1.3s.1 1 .5 1.3c.4.5.7.6 1.3.6.5 0 1-.3 1.5-.5v-1.5h-1.5v.5h.9v.6c-.3.3-.5.4-.9.4s-.6-.1-.9-.4c-.1-.3-.3-.6-.3-.9 0-.4.1-.6.3-.9.3-.3.5-.4.9-.4zM7.5 19.7l.4.9h.6L7 17h-.7l-1.5 3.6h.6l.4-.9h1.7zm-.8-2l.6 1.4H6.1l.6-1.4zM28.7 18.2c0-.3-.1-.5-.3-.8-.3-.3-.6-.4-1-.4h-1.5v3.6h.4v-1.3h.8l.9 1.3h.8l-1-1.4c.5-.1.9-.5.9-1zm-1.5.5h-.9v-1.2h.9c.5 0 .8.3.8.6 0 .4-.3.6-.8.6zM30.2 17h.6v3.6h-.6zM24.2 20.6L22.7 17h-.6l-1.6 3.6h.6l.4-.9h1.7l.4.9h.6zm-2.4-1.5l.6-1.4.6 1.4h-1.2zM2 21.5s-.2-.1-.3-.1H.2V24H1v-1h.5c.2 0 .3 0 .5-.1.2 0 .3-.2.3-.3.1-.1.1-.3.1-.4 0-.1-.1-.3-.1-.4l-.3-.3zm-.4 1.1c0 .1-.2.1-.3.1H1v-.8h.3c.2 0 .2.1.3.1.1.2.1.1.1.3s0 .3-.1.3zM4.8 21.8c-.1-.2-.3-.3-.4-.3-.1-.1-.4-.1-.5-.1-.2 0-.3 0-.6.1-.1 0-.3.2-.4.3-.2.1-.3.3-.3.4-.1.1-.1.4-.1.5 0 .1.2.4.3.5 0 .1.2.3.3.4.1.2.3.2.4.3.1.1.4.1.5.1s.4 0 .5-.1c.1 0 .3-.2.4-.3.1-.1.1-.3.2-.4.1-.1.1-.4.1-.5 0-.1 0-.4-.1-.5 0-.1-.2-.3-.3-.4zm-.1.9v.3c0 .2-.1.3-.1.3-.2 0-.2.1-.3.1h-.6c-.2 0-.3-.1-.3-.1 0-.2-.1-.2-.1-.3v-.3-.3c0-.2.1-.3.1-.3.2 0 .2-.1.3-.1h.6c.2 0 .3.1.3.1 0 .2.1.2.1.3v.3zM7.9 22.8c.1-.1.1-.4.1-.5 0-.1-.1-.4-.2-.5-.1-.2-.3-.3-.4-.3-.1-.1-.4-.1-.5-.1H5.7V24h.6v-.8h.3l.5.8h1l-.6-.9c.1 0 .3-.2.4-.3zm-.8-.2c-.2.1-.2.1-.3.1h-.5v-.8h.5c.2 0 .2.1.3.1.1.2.1.1.1.3s0 .3-.1.3zM8.1 22.1h.7V24h.7v-1.9h.7v-.7H8.1zM11.4 21.4L10.3 24h.8l.2-.6h1l.1.5h.6l-1-2.5h-.6zm.1 1.6l.2-.6.3.6h-.5zM15.2 21.4l-1 2.6h.6l.3-.6h.9v.5h.8l-1-2.5h-.6zm0 1.6l.3-.6.4.6h-.7zM20 21.5c-.1 0-.3-.1-.4-.1h-1.4V24h.6v-1h.8c.1 0 .3 0 .4-.1.2 0 .3-.2.3-.3.1-.1.1-.3.1-.4 0-.1-.1-.3-.1-.4l-.3-.3zm-.5 1.1c0 .1-.2.1-.3.1h-.4v-.8h.4c.2 0 .2.1.3.1.1.2.1.1.1.3s0 .3-.1.3zM22.6 21.9c-.1-.2-.3-.3-.4-.3-.2-.1-.6-.1-1 0-.2.1-.5.3-.6.6-.1.1-.1.4-.1.5 0 .1 0 .4.1.5 0 .1.2.3.3.4.1.2.3.2.4.3.1.1.4.1.5.1h.4c.1 0 .3-.2.4-.3.2-.1.2-.3.3-.4.1-.1.1-.4.1-.5 0-.1 0-.4-.1-.5 0-.1-.2-.3-.3-.4zm-.1.8v.3c0 .2-.1.3-.1.3-.2 0-.1.1-.3.1h-.6c-.2 0-.3-.1-.3-.1 0-.2-.1-.2-.1-.3v-.3-.3c0-.2.1-.3.1-.3.2 0 .1-.1.3-.1h.6c.2 0 .3.1.3.1 0 .2.1.2.1.3v.3zM25.7 22.8c.1-.1.1-.4.1-.5 0-.1-.2-.4-.3-.5 0-.2-.2-.3-.3-.3-.1-.1-.4-.1-.5-.1h-1.1V24h.6v-.8h.3l.5.8h.9l-.6-.9c.1 0 .3-.2.4-.3zm-.8-.2c-.2.1-.2.1-.3.1h-.5v-.8h.5c.2 0 .2.1.3.1.1.2.1.1.1.3s-.1.3-.1.3zM28.1 21.4h-2.2v.7h.8V24h.7v-1.9h.7zM29.3 21.4L28.1 24h.8l.2-.5h.9l.1.5h.8l-1-2.6h-.6zm0 1.6l.2-.6.3.6h-.5zM25.3 2.1L21.5 0l-4.7 1 3.7 2.1zM19.9 5.4l-3.8-2.2-4.6 1.2 3.7 2.1zM8.4 2.1L4.6 0 0 1l3.7 2.2zM10.1 11.9l.1.3h.3l.5-.2h.6c.1 0 .4-.1.5-.1l.5-.1.4-.2h1.2V7.4l-4.6 1V11l.2.4c.1.1.1.4.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 11.6l-2 .5-1.2.3-1.2.2-.4-.7V16l1.7-.4v-2.2l1.4-.2v2.2l1.7-.4zM19.9 9.8V5.5l-4.6 1v2.6l.1.3.1.4c.1.1.1.3.1.4v.1h.3l.6-.1h.5l.6-.1.6-.1.8-.2h.5l-1.6.4-1.1.3-1.2.2h-.1l-.3-.6v4.1l1.7-.4v-2.2l1.4-.4v2.2l1.6-.2V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 3.1v-.6l-.9.1v-.4L3.7 3.4l-.1 13 4.8-1V7.7l1.1.6 4.8-1.1L10.6 5l-2.2.5V4.3l.6-.4v-.4l-.6.2v-.2zM2.5 12c0-.5-.1-1-.4-1.4-.4-.3-.9 0-.9.5V14.8l1.3 1V12zM26.4 8.9v1l.1.7c.1.1.1.4.3.5l.1.3.3-.1.6-.1.2-.2h.3c.3 0 .4-.1.6-.1l.6-.1.6-.1H31V7.9l-4.6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 11.6l-1.2.3h-.1l-.4-.9v3.6l1.9-.4V12l1.3-.3v2.2l1.6-.4v-2.7l-2 .4z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-repeat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 66"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-school",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 73"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-search",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-select_all",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 75"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-sentiment_dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 26"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-settings",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 0 0-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-settings_applications",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07a.306.306 0 0 0-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59a.31.31 0 0 0-.3-.25h-2.4a.31.31 0 0 0-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 16H5V5h14v14z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-suape",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cust0",
    d: "M2.2 14h.2l7.2-2.2c.3 0 .4-.3.3-.6-.1-.3-.4-.5-.7-.4L2.1 13c-.4.1-.5.3-.4.6.1.3.3.4.5.4zM9.2 14.1l-7.1 1.5c-.3 0-.4.3-.4.6s.2.4.5.4h.1l7.1-1.5c.3 0 .4-.3.4-.6s-.3-.4-.6-.4zM9.3 17.4l-7.1.8c-.3.1-.5.3-.5.6.1.2.3.4.5.4l7.3-.8c.2-.1.4-.3.4-.6-.1-.2-.3-.5-.6-.4zM9.3 20.9H2.2c-.3 0-.5.2-.5.5s.2.5.5.5h7.1c.4 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cust0",
    d: "M23.7 2.4L16.3 0h-.4L9 3.1c-.2.1-.3.3-.3.5v3.7L.3 11.1c-.2 0-.3.2-.3.4v12c0 .3.2.5.5.5h23c.3 0 .5-.2.5-.5V2.9c0-.2-.2-.4-.3-.5zM1 11.8l10.4-4.7V23H1V11.8zM15.9 23h-3.5V7.1l5 1.7V23h-1.5zm7.1 0h-4.6V8.4c0-.1-.1-.3-.3-.4l-6-2.1h-.4l-2 .9V3.9L16.2 1 23 3.3V23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cust0",
    d: "M20.5 6.8c.3 0 .5-.1.5-.5V4.4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.9c0 .3.2.5.5.5zM20.5 10.4c.3 0 .5-.2.5-.6V7.9c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2c0 .3.2.5.5.5zM20.5 13.9c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2c0 .3.2.5.5.5zM20.5 17.4c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2c0 .3.2.5.5.5zM20.5 20.9c.3 0 .5-.2.5-.5v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2c0 .3.2.5.5.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-supervised_user_circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86A9.05 9.05 0 0 0 9.5 14c-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78a7.935 7.935 0 0 1-5.66-2.86z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-tab",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0zm0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-telegram",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.99 5.564l-3.055 14.063c-.072.332-.48.483-.766.283l-4.17-2.897a.714.714 0 0 0-.84.022L9.845 18.84c-.268.21-.672.093-.775-.223l-1.605-4.942-4.148-1.482a.461.461 0 0 1-.005-.875l17.022-6.285c.36-.133.733.17.654.532zm-4.072 2.543l-8.106 4.778a.766.766 0 0 0-.356.88l.876 2.947c.062.208.379.187.41-.029l.227-1.616a1.31 1.31 0 0 1 .43-.794l6.69-5.952c.125-.111-.025-.3-.17-.214z",
    "data-name": "Livello 71"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-today",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-touch_app",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 29"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cza",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.12 14.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32C17 5.47 14.53 3 11.5 3S6 5.47 6 8.5c0 2.13 1.22 3.98 3 4.89v3.26l-1.84-.39-.1-.02c-.1-.02-.2-.03-.32-.03-.53 0-1.03.21-1.41.59l-1.4 1.42 5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zm-.35 2.85l-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V8.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8 8.5C8 6.57 9.57 5 11.5 5S15 6.57 15 8.5c0 .95-.38 1.81-1 2.44V8.5a2.5 2.5 0 0 0-5 0v2.44c-.62-.63-1-1.49-1-2.44z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-transfer_within_a_station",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-translate",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 30"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-twitter",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.137 8.656c.023.094.035.246.035.457 0 1.688-.41 3.317-1.23 4.887-.844 1.664-2.028 2.988-3.551 3.973-1.664 1.101-3.575 1.652-5.73 1.652-2.063 0-3.95-.55-5.661-1.652.258.023.55.035.879.035 1.71 0 3.246-.528 4.605-1.582-.82 0-1.54-.24-2.162-.72a3.671 3.671 0 0 1-1.283-1.811c.234.023.457.035.668.035.328 0 .656-.035.984-.106a3.72 3.72 0 0 1-2.109-1.3 3.54 3.54 0 0 1-.844-2.32v-.071a3.475 3.475 0 0 0 1.653.492 4.095 4.095 0 0 1-1.196-1.336 3.546 3.546 0 0 1-.457-1.775c0-.645.176-1.26.528-1.846A10.18 10.18 0 0 0 7.623 8.41a10.219 10.219 0 0 0 4.236 1.125 5.124 5.124 0 0 1-.07-.844c0-.656.164-1.271.492-1.845a3.613 3.613 0 0 1 1.336-1.354A3.565 3.565 0 0 1 15.445 5c.54 0 1.037.105 1.494.316.457.211.862.493 1.213.844a7.51 7.51 0 0 0 2.356-.879c-.281.867-.82 1.547-1.617 2.04A7.93 7.93 0 0 0 21 6.722a8.114 8.114 0 0 1-1.863 1.933z",
    "data-name": "Livello 72"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-ufficicitta",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 5.1V0C7.4.9 4.9-.1 2 2.6.8 3.9.1 5.3 0 7.1V24h27.3V7.1c-.3-.2-5-1.6-11.4-2zM2.8 3.4c2.4-2.4 4.7-1.5 12-2.1v3.9c-4.6-.2-9.1.4-13.7 1.5.3-1.2.8-2.4 1.7-3.3zm5.8 19.5H7.3v-3.2h1.4c-.1 0-.1 3.2-.1 3.2zm5.7 0H13v-3.2h1.4v3.2zm5.7 0h-1.4v-3.2H20v3.2zm6.2 0h-5v-4.3h-3.6v4.3h-2v-4.3H12v4.3h-2v-4.3H6.1v4.3h-5v-6.4c8.3-2 16.6-2.2 25 0v6.4zM7.3 14.1v-3.4h1.4v3.2c-.5.2-1 .2-1.4.2zm5.7-.7v-3.2h1.4v3.2H13zm5.7.6v-3.2H20v3.4c-.4-.1-.9-.1-1.3-.2zm7.5 1.4c-1.7-.5-3.4-.8-5-1V9.7h-3.6V14c-.7 0-1.4-.1-2-.1V9.1H12v4.7c-.7 0-1.4.1-2 .1V9.6H6.1v4.7c-1.6.3-3.3.7-5 1.1V8c8.4-2.3 16.7-2.3 25 0v7.4z",
    "data-name": "Livello 88"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-verified_user",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 76"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-vertical_split",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-warning",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    "data-name": "Livello 24"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.327 5.622A8.984 8.984 0 0 0 3 11.965a8.883 8.883 0 0 0 1.38 4.778l.202.336-.892 3.365 3.365-.891.336.185a8.9 8.9 0 0 0 4.56 1.261 8.984 8.984 0 0 0 6.376-15.377zm-1.396 9.809a2.793 2.793 0 0 1-1.817 1.278 3.752 3.752 0 0 1-1.683-.1c-.387-.135-.891-.304-1.53-.573a12.046 12.046 0 0 1-4.678-4.071 5.266 5.266 0 0 1-1.11-2.793c-.01-.85.33-1.665.942-2.255a.993.993 0 0 1 .723-.336h.455c.168 0 .386 0 .605.454.219.454.757 1.868.825 2.002a.505.505 0 0 1 0 .471c-.07.163-.16.316-.27.455a6.374 6.374 0 0 1-.403.47c-.118.118-.286.287-.118.556a7.958 7.958 0 0 0 1.497 1.867 7.251 7.251 0 0 0 2.17 1.346c.27.135.421.101.573 0 .151-.1.673-.79.858-1.06.185-.269.353-.235.605-.134.253.1 1.582.74 1.851.875.27.134.438.202.505.32.095.406.078.83-.05 1.228h.05z",
    "data-name": "Livello 73"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-work_outline",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 62"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.516 6.514c-.252-.984-.99-1.755-1.936-2.023C18.864 4 12 4 12 4s-6.864 0-8.58.48c-.949.27-1.687 1.045-1.935 2.034A30.508 30.508 0 0 0 1 12a30.51 30.51 0 0 0 .462 5.486c.255.99 1.003 1.762 1.958 2.023C5.136 20 12 20 12 20s6.863 0 8.579-.48c.946-.267 1.684-1.038 1.936-2.023.327-1.812.489-3.653.484-5.497a30.508 30.508 0 0 0-.484-5.486zM9.8 15.43V8.57L15.51 12 9.8 15.429z",
    "data-name": "Livello 74"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "ca-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Livello 90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,8.3c0-1-0.2-1.6-0.4-2.2c-0.2-0.6-0.6-1.1-1-1.6c-0.5-0.5-1-0.8-1.6-1c-0.6-0.2-1.2-0.4-2.2-0.4C14.8,3,14.4,3,12,3                         C9.6,3,9.3,3,8.3,3.1c-1,0-1.6,0.2-2.2,0.4C5.5,3.7,5,4.1,4.5,4.5c-0.5,0.5-0.8,1-1,1.6C3.3,6.7,3.1,7.3,3.1,8.3C3,9.3,3,9.6,3,12                         s0,2.7,0.1,3.7c0,1,0.2,1.6,0.4,2.2c0.2,0.6,0.6,1.1,1,1.6c0.5,0.5,1,0.8,1.6,1c0.6,0.2,1.2,0.4,2.2,0.4c1,0,1.3,0.1,3.7,0.1                         c2.4,0,2.8,0,3.7-0.1c1,0,1.6-0.2,2.2-0.4c1.2-0.5,2.2-1.4,2.6-2.6c0.2-0.6,0.4-1.2,0.4-2.2c0-1,0.1-1.3,0.1-3.7S21,9.3,21,8.3z                          M19.3,15.6c0,0.9-0.2,1.4-0.3,1.7c-0.3,0.8-0.9,1.4-1.7,1.7c-0.3,0.1-0.8,0.3-1.7,0.3c-0.9,0-1.2,0.1-3.6,0.1                         c-2.4,0-2.7,0-3.6-0.1c-0.9,0-1.4-0.2-1.7-0.3c-0.4-0.1-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.1-0.3-0.3-0.8-0.3-1.7                         c0-0.9-0.1-1.2-0.1-3.6c0-2.4,0-2.7,0.1-3.6C4.7,7.5,4.9,7,5,6.7c0.1-0.4,0.4-0.7,0.7-1C6,5.4,6.3,5.1,6.7,5C7,4.9,7.5,4.7,8.4,4.7                         c0.9,0,1.2-0.1,3.6-0.1c2.4,0,2.7,0,3.6,0.1c0.9,0,1.4,0.2,1.7,0.3c0.4,0.1,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.7,1                         c0.1,0.3,0.3,0.8,0.3,1.7c0,0.9,0.1,1.2,0.1,3.6C19.4,14.4,19.4,14.7,19.3,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7.4c-2.6,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6c2.6,0,4.6-2.1,4.6-4.6S14.6,7.4,12,7.4z M12,15c-1.7,0-3-1.3-3-3                         s1.3-3,3-3c1.7,0,3,1.3,3,3S13.7,15,12,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,6.1c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C17.9,6.6,17.4,6.1,16.8,6.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPonmetroca);
export default __webpack_public_path__ + "static/media/ponmetroca.06378584c9bd402b170e5105e2dc93bb.svg";
export { ForwardRef as ReactComponent };